const exports = {
  transition: {
    default: '500ms',
    fast: '250ms',
  },
}

export default exports
